module.exports = __webpack_public_path__ + "static/media/wheel_aligemnt.36b5bf1b.svg";